export class GenerateUsernameRequest {
    Domain: string;
    FirstName: string;
    LastName: string;
}
